import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { BOOKLET_CHIP_BASE, BOOKLET_CHIP_CLASS, type BookletChipVariant } from './bookletChip';

/** [P7B.1 §2] One chip of the review site's vocabulary — see `bookletChip.ts` for the four shapes. */
export const BookletChip = ({
  variant,
  children,
  title,
}: {
  variant: BookletChipVariant;
  children: ReactNode;
  /** A native `title`, never an AntD `Tooltip` — one per chip is a measured cost ([D4.4] #82). */
  title?: string;
}): React.ReactElement => (
  <span
    className={cn(BOOKLET_CHIP_BASE, BOOKLET_CHIP_CLASS[variant])}
    data-chip={variant}
    {...(title === undefined ? {} : { title })}
  >
    {children}
  </span>
);
